import { render, staticRenderFns } from "./StartseiteArvea.vue?vue&type=template&id=3862daf9"
import script from "./StartseiteArvea.vue?vue&type=script&lang=js"
export * from "./StartseiteArvea.vue?vue&type=script&lang=js"
import style0 from "./StartseiteArvea.vue?vue&type=style&index=0&id=3862daf9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports